export default "__VITE_ASSET__Cwuv5tLY__"